import {
  Alert,
  Box,
  Card,
  CardContent,
  Snackbar,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { fifthCardCss } from '../siteAudit/siteAuditCSS';
import SearchProgress from '../keywordResearch/SearchProgress';
import { UpgradePlanLiteModal } from '../keywordResearch/UpgradePlanLiteModal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import BacklinksDataTable from './BacklinksDataTable';
import {
  keywordOverviewCss,
  KeywordOverviewResultCardsCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { BackLinkAllTexts } from './BackLinkAllTexts';
import { getBackLinksDetails, getCreditDetails } from 'src/common/Scraper';
import {
  setbackLinkData,
  setBackLinkFilters,
  setBackLinkSection,
  setIsAgencyUpgrade
} from 'src/redux/keywordResearch';
import { StripeLoader } from 'src/common/StripeLoader';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import {
  keywordOverviewTexts,
  loginBackgroundPath,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import {
  isLocalSeoUser,
  openNewTab,
  getWindowInnerHight,
  getNormalizedPlan
} from 'src/common/config/FunctionHelper';
import { SearchBackLinkComponent } from './SearchBackLinkComponent';
import { BackLinkInfo } from './BackLinkInfo';
import { BackLinkCards } from './BackLinkCards';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import HelpIcon from '@mui/icons-material/Help';
import CommonKeywordSnackBar from '../keywordResearch/CommonKeywordSnackbar';
import { useChromeBrowserBanner } from 'src/hooks/useChromeBrowserBanner';
import { useBrowserType } from 'src/hooks/useBrowserType';
import { NewCommonChromeExtensionModal } from 'src/common/NewCommomChromeExtensionModal';
import { UpgradeToAgency } from '../keywordResearch/keywordTracking/UpgradeToAgency';
import { KeywordTrackingAllTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import { localSeoTexts } from '../localSeo/localSeoTexts';
import { Helmet } from 'react-helmet-async';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';
import ScrollToTop from 'src/components/Scrollbar/ScrollToTop';
import UpgradeWarningPlan from 'src/common/UpgradeWarningPlan';
import { upgradeWarningPlanSx } from 'src/common/CommomSxs';

const BackLinkPage = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [nextToken, setNextToken] = useState(null);
  const [searchedUrl, setSearchedUrl] = useState('');
  const [getMoreLoader, setGetMoreLoader] = useState(false);
  const [getIsMore, setIsGetMore] = useState(false);
  const [openPlanModal, setOpenPlanModal] = useState(false);
  const [backLinkSnackBar, setBackLinkSnackBar] = useState(null);
  const navigate = useNavigate();
  const { isChromeBrowser } = useBrowserType();
  const { NotAChromeBrowserBanner } = useChromeBrowserBanner();
  const searchesDetailRedux: any = useSelector(
    (state: RootState) => state.keywordResearch.searchesDetails
  );
  let siteAuditDetails = useSelector(
    (state: RootState) => state.siteAudit.siteAuditDetails
  );
  const competitorAnalysisUrl: any =
    useSelector(
      (state: RootState) => state.keywordResearch.competitorAnalysisUrl
    ) ?? '';
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  const backLinkSection: any =
    useSelector((state: RootState) => state.keywordResearch.backLinkSection) ??
    0;
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const isAgencyUpgrade =
    useSelector((state: RootState) => state.keywordResearch.isAgencyUpgrade) ??
    false;
  const isUnlocked =
    useSelector(
      (state: RootState) => state.keywordResearch.isUnlockedBackLink
    ) ?? false;
  const normalizedPlan = getNormalizedPlan(activePlanName, planDetails);
  const isStarter = normalizedPlan === planDetails?.diy;
  const isStarterPlus = normalizedPlan === planDetails?.starterPlus;
  const isPro = normalizedPlan === planDetails?.pro || normalizedPlan === planDetails?.designer || normalizedPlan === planDetails?.proPlus;
  const isAgency = normalizedPlan === planDetails?.agency;
  const isExpertPlus = normalizedPlan === planDetails?.expertPlus;
  const isEnterprise = normalizedPlan === planDetails?.enterprise;
  const isOldPlan = stripeSubscriptionDetails?.planVersion == 'v1'

  const isActiveBacklink = isOldPlan ? (isAgency || isExpertPlus || isEnterprise || isUnlocked) :
    (isStarter || isStarterPlus || isPro || isAgency || isExpertPlus || isEnterprise || isUnlocked);

  const isFreePlan = activePlanName === planDetails?.free;
  const dispatch = useDispatch();
  const totalAddonLimit = searchesDetailRedux?.totalAddonLimit || 0;
  const totalAddonUsedLimit = searchesDetailRedux?.totalAddonUsedLimit || 0;

  const finalizedUsedLimit =
    (searchesDetailRedux?.usedLimit || 0) + totalAddonUsedLimit;
  const finalizedAddonUsedLimit =
    (searchesDetailRedux?.totalLimit || 0) + totalAddonLimit;
  const isLocalSeo = isLocalSeoUser();
  useEffect(() => {
    setShowBanner(
      finalizedUsedLimit >= finalizedAddonUsedLimit &&
        finalizedUsedLimit !== 0 &&
        finalizedAddonUsedLimit !== 0
    );
    setOpenPlanModal(
      finalizedUsedLimit >= finalizedAddonUsedLimit &&
        finalizedUsedLimit !== 0 &&
        finalizedAddonUsedLimit !== 0
    );
  }, [finalizedUsedLimit, finalizedAddonUsedLimit]);

  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {BackLinkAllTexts?.otherTools}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {BackLinkAllTexts?.backLinkAnalysis}
    </Typography>
  ];

  useEffect(() => {
    if (competitorAnalysisUrl && competitorAnalysisUrl?.length > 0) {
      getBackLinksDetailsFunc();
    } else {
      setLoader(false);
      getSearchesDetail();
    }
  }, [competitorAnalysisUrl]);

  useEffect(() => {
    dispatch(setIsAgencyUpgrade(false));
    if (!competitorAnalysisUrl && competitorAnalysisUrl?.length == 0) {
      dispatch(setBackLinkSection(0));
    }
  }, []);

  const getBackLinksDetailsFunc = async (
    isMore = false,
    url = competitorAnalysisUrl
  ) => {
    if (isMore) {
      setGetMoreLoader(true);
    } else {
      setLoader(true);
    }
    let payload;
    if (isMore) {
      payload = {
        url: searchedUrl || url,
        searchAfterToken: nextToken
      };
    } else {
      payload = {
        url: url
      };
    }
    const getBackLinksDetailsResponse: any = await getBackLinksDetails(payload);
    setIsGetMore(isMore);
    setBackLinkSnackBar({
      status: getBackLinksDetailsResponse?.status,
      message: getBackLinksDetailsResponse?.message
    });
    if (getBackLinksDetailsResponse?.status == 'success') {
      dispatch(
        setBackLinkFilters({
          searchVolume: null,
          kd: null,
          position: null,
          intent: null,
          keywordGoldenRation: null,
          wordCount: null,
          spamScore: null
        })
      );
      if (isMore) {
        setRowData((prev) => [
          ...prev,
          ...getBackLinksDetailsResponse?.backlinksData
        ]);
        dispatch(
          setbackLinkData((prev) => [
            ...prev,
            ...getBackLinksDetailsResponse?.backlinksData
          ])
        );
      } else {
        setRowData(getBackLinksDetailsResponse?.backlinksData);
        dispatch(setbackLinkData(getBackLinksDetailsResponse?.backlinksData));
      }
      setNextToken(getBackLinksDetailsResponse?.nextToken);
      if (!isMore) {
        setCardData(getBackLinksDetailsResponse?.cardDetails);
        dispatch(setBackLinkSection(1));
      }
    }
    if (!isMore) {
      getSearchesDetail();
    }
    if (isMore) {
      setGetMoreLoader(false);
    } else {
      setLoader(false);
    }
    setTimeout(() => {
      setBackLinkSnackBar(null);
    }, 5000);
  };

  const getSearchesDetail = async () => {
    let getSearchesDetail: any = await getCreditDetails();

    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
  };
  const handleCloseOpenPlanModal = () => {
    setOpenPlanModal(false);
  };
  const handleCloseBackLinkSnackBar = () => {
    setBackLinkSnackBar(null);
  };
  const getKeywordTrackingFunc = () => {};

  const handleCloseSnackBar = () => {
    dispatch(setIsAgencyUpgrade(false));
  };

  return (
    <div>
      <Helmet>
        <title>
          {isLocalSeo
            ? `${SEOSpaceLocal} | Backlink Analysis`
            : localSeoTexts?.backLinkHelmetText}
        </title>
      </Helmet>
      {isAgencyUpgrade && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isAgencyUpgrade}
          autoHideDuration={5000}
          onClose={handleCloseSnackBar}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleCloseSnackBar}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {KeywordTrackingAllTexts?.upgradeSuccessMessage}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!isLocalSeo && isPremiumUser && NotAChromeBrowserBanner}
      {isChromeBrowser && isPremiumUser && !isLocalSeo && (
        <NewCommonChromeExtensionModal />
      )}
      {backLinkSnackBar?.status && !openPlanModal && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={backLinkSnackBar?.status && !openPlanModal}
          autoHideDuration={5000}
          onClose={handleCloseBackLinkSnackBar}
        >
          <Box>
            <Alert
              icon={
                backLinkSnackBar?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleCloseBackLinkSnackBar}
              severity={backLinkSnackBar?.status}
              variant="filled"
              sx={{
                ...(backLinkSnackBar?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  backLinkSnackBar?.status === 'success'
                    ? 'var(--color-success-bg-ultra)'
                    : 'var(--color-error-bg)',
                border:
                  backLinkSnackBar?.status === 'success'
                    ? '1px solid var(--color-success-border)'
                    : '1px solid var(--color-error-red)',
                maxWidth: '667px'
              }}
            >
              {backLinkSnackBar?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {(stripeLoader || (!searchesDetailRedux?.totalLimit && !isFreePlan)) && (
        <StripeLoader />
      )}
      {!stripeLoader &&
        !isPremiumUser &&
        stripeSubscriptionDetails?.subscription_id && (
          <Box
            sx={{
              backgroundImage: `url(${loginBackgroundPath})`, // Replace with your image URL
              minHeight: getWindowInnerHight(63), // Set a minimum height for visibility
              ...upgradeWarningPlanSx?.mainBgBoxSx
            }}
          >
            <UpgradeWarningPlan />
          </Box>
        )}
      {!stripeLoader && isPremiumUser && (
        <Box sx={keywordOverviewCss?.breadcrumbsMainBoxNew}>
          <Box></Box>
          <Box sx={keywordOverviewCss?.userTutorialBox}>
            <img
              onClick={() => {
                openNewTab(keywordOverviewTexts?.backLinkTutorialsLink);
              }}
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/keyword/book-open-02.svg`
              }
              alt="icon"
            />
            <Typography
              onClick={() => {
                openNewTab(keywordOverviewTexts?.backLinkTutorialsLink);
              }}
              sx={keywordOverviewCss?.userTutorial}
            >
              {BackLinkAllTexts?.backLinkAnalysisTutorial}
            </Typography>
          </Box>
        </Box>
      )}
      {(isActiveBacklink) && !isAgencyUpgrade && (
        <CommonKeywordSnackBar
          open={openPlanModal}
          handleClose={handleCloseOpenPlanModal}
        />
      )}
      {!stripeLoader && showBanner && (
        <Box className="mt-3">
          <UpgradePlanLiteModal />
        </Box>
      )}
      {!stripeLoader && (isActiveBacklink) && (
        <Box className="mt-3">
          <SearchProgress />
        </Box>
      )}
      {!stripeLoader && (isActiveBacklink) && (
        <>
          {backLinkSection == 1 && <ScrollToTop />}
          <Card sx={fifthCardCss.card} className="scan-data-table">
            <CardContent sx={fifthCardCss.cardContent}>
              <Box
                sx={{
                  marginBottom: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Helvetica',
                    fontWeight: 700,
                    fontSize: '26px',
                    lineHeight: 'var(--line-height-38)',
                    color: 'var(--color-primary)',
                    display: 'inline-block'
                  }}
                >
                  {BackLinkAllTexts?.backLinkAnalysis}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        {BackLinkAllTexts?.backLinkTooltip}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box>
                <SearchBackLinkComponent
                  getBackLinksDetailsFunc={getBackLinksDetailsFunc}
                  loader={loader}
                  setSearchedUrl={setSearchedUrl}
                  openPlanModal={showBanner}
                />
              </Box>
              {backLinkSection == 1 && (
                <Box sx={{ marginTop: '32px' }}>
                  <BackLinkCards cardData={cardData} loader={loader} />
                </Box>
              )}
              {backLinkSection == 0 && <BackLinkInfo />}
            </CardContent>
          </Card>
          {backLinkSection == 1 && (
            <Card sx={fifthCardCss.card} className="scan-data-table">
              <CardContent sx={fifthCardCss.cardContent}>
                <Box>
                  <BacklinksDataTable
                    rowData={rowData}
                    loader={loader}
                    getBackLinksDetailsFunc={getBackLinksDetailsFunc}
                    getMoreLoader={getMoreLoader}
                    nextToken={nextToken}
                    getIsMore={getIsMore}
                    searchedUrl={searchedUrl || competitorAnalysisUrl}
                  />
                </Box>
              </CardContent>
            </Card>
          )}
        </>
      )}
      {!isActiveBacklink &&
        !stripeLoader &&
        searchesDetailRedux?.totalLimit && (
          <Card sx={keywordOverviewCss?.card}>
            <CardContent sx={keywordOverviewCss?.cardContent}>
              <UpgradeToAgency
                getKeywordTrackingFunc={getKeywordTrackingFunc}
                isBackLink={true}
              />
            </CardContent>
          </Card>
        )}
    </div>
  );
};

export default BackLinkPage;
